import tw from 'twin.macro';
import styled from 'styled-components';

const Heading2 = styled.h2(() => [tw`text-4xl md:text-5xl mt-8 mb-6 font-semibold`]);

export default Heading2;
